import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { EUserRight } from '@web/dtos';
import { AuthProviderFactory } from '../../services/auth/auth-provider.factory';
import { UserStore } from '../../services/api/user/user/user-store.service';

@Pipe({
  name: 'hasAccessRight',
})
@Injectable({ providedIn: 'root' })
export class HasAccessRightPipe implements PipeTransform {
  private authFactory: AuthProviderFactory = inject(AuthProviderFactory);
  private userStore: UserStore = inject(UserStore);

  transform(value: EUserRight): boolean {
    const auth = this.authFactory.getProvider('cms');

    return (
      auth.isLoggedIn() && this.matchUserRight(value, this.userStore.rights())
    );
  }

  private matchUserRight(
    requiredRight: EUserRight,
    grantedRights: EUserRight[]
  ): boolean {
    return grantedRights.includes(requiredRight);
  }
}
